import React from "react"
import { useHistory } from "react-router-dom"
import { useForm, FormProvider } from "react-hook-form"
import SignUpPage from "components/signup"
import { SignUpProvider } from "components/signup/context/SignUpContext"
import { trackMatomoPageView } from "utils/matomo"

const SignUp = (): JSX.Element => {
  const history = useHistory()

  const formMethods = useForm({ reValidateMode: "onSubmit" })
  const { handleSubmit, setError, getValues } = formMethods

  function onSuccessfulSignUp(): void {
    const signupSuccessHref = `/signup-success?email=${encodeURIComponent(getValues("email"))}`
    history.push(signupSuccessHref)
    trackMatomoPageView(signupSuccessHref)
  }

  return (
    <SignUpProvider {...{ handleSubmit, setError, onSuccessfulSignUp }}>
      <FormProvider {...formMethods}>
        <SignUpPage />
      </FormProvider>
    </SignUpProvider>
  )
}

export default SignUp
